module.exports = __webpack_public_path__ + "static/img/wdfy.4e3abb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/wdfy.png
// module id = Bwxq
// module chunks = 1